<template>
  <div>
    <div class="container admin-wrap" style="margin-top: 10px">
      <K2Row space-between="true">
        <div class="text-left">
          <h4 class="text-left">
            {{ lang('View Learning Goals') }}
          </h4>
        </div>
        <K2Row id="button-area" class="col-lg-24 text-right actionDiv">
          <K2Button size="small" type="primary" :plain="true" @onclick="viewLearningGoals">
            <K2Text color="#409EFF">{{ lang('View Learning Goals (Full Version)') }}</K2Text>
          </K2Button>
        </K2Row>
      </K2Row>
      <div class="row header mb-5">
        <!--<div class="col-lg-5 ">-->
        <!--<h3 class="text-left mb-3">-->
        <!--&lt;!&ndash;{{$route.name}}&ndash;&gt;-->
        <!--{{lang("PN-N1 Learning Goals")}}-->
        <!--</h3>-->
        <!--</div>-->
        <div class="pb-5">
          <div class="empty-list_image" v-if="ddlLevels.length < 1">
            <strong>{{ lang('No Data Found') }}...</strong>
            <img :src="assets.image.notFound" />
          </div>

          <div id="level-select-table" v-if="ddlLevels.length > 0">
            <data-tables :page-size="100" :data="ddlLevels">
              <el-table-column v-for="Levels in LevelInfo" :prop="Levels.prop" :label="Levels.label" :key="Levels.prop"> </el-table-column>
              <el-table-column :label="lang('Level Assign')" min-width="100px">
                <template slot-scope="scope">
                  <el-button type="primary" @click="levelSelect(scope.row)">
                    {{ lang('View') }}
                  </el-button>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { lang, selectedLocale } from '../../locale/index'
import DataSource from '../../data/datasource'
import Cookies from 'js-cookie'
import assets from '../../assets/assets'
import './planner.scss'
import K2Button from '../../uiComponents/k2Button/k2Button'
import K2Row from '../../uiComponents/k2Row/k2Row'
import K2Text from '../../uiComponents/k2Text/k2Text'

export default {
  name: 'PlannerLevel',
  components: { K2Text, K2Row, K2Button },
  data() {
    return {
      assets: assets,
      ddlLevels: [],
      schID: '',
      crsID: '',
      level: '',
      semID: '',
      LevelInfo: [
        // {
        //   prop: "academicYear",
        //   label: lang("Academic Year")
        // },
        {
          prop: 'CRS_Course_Name',
          label: lang('Course Name'),
        },
        // {
        //   prop: "GoalCount",
        //   label: lang("No of assigned Goals")
        // }
      ],
    }
  },
  async created() {
    this.schID = Cookies.get('schoolSession')
    await this.bindLevels()
  },
  methods: {
    lang,
    viewLearningGoals() {
      window.open(
        'https://sites.google.com/etonhouse.edu.sg/pedagogy/eh-curriculum-docs-%E4%BC%8A%E9%A1%BF%E8%AF%BE%E7%A8%8B%E7%9B%B8%E5%85%B3%E6%96%87%E6%A1%A3',
        '_blank',
      )
    },
    async bindLevels() {
      try {
        const academicYearList = await this.getAcademicYear()
        const response = await DataSource.shared.getLevelList(this.schID)

        response.Table?.forEach(d => {
          let academicYear = academicYearList.find(a => a.PK_Semester_ID === d.ClS_FK_Semester_ID)
          d.academicYear = academicYear?.SMT_Code
        })

        // for pn, n1 only
        // let allowLevel=response.Table.filter(d=>d.CRS_Level === "N1"||d.CRS_Level === "PN")
        this.ddlLevels = response.Table
      } catch (e) {
        this.results = e
      }
    },
    async getAcademicYear() {
      try {
        const response = await DataSource.shared.getAcademicYear('')
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else {
            return response.Table
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    resetAll() {
      this.ddlGoalsList = []
      this.ddlGoalsListDomain = []
      this.ddlTerm1LevelGoalsList = []
      this.ddlTerm2LevelGoalsList = []
      this.ddlTerm3LevelGoalsList = []
      this.ddlTerm4LevelGoalsList = []

      this.ddlTerm1ClassGoalsList = []
      this.ddlTerm2ClassGoalsList = []
      this.ddlTerm3ClassGoalsList = []
      this.ddlTerm4ClassGoalsList = []

      this.ddlTerm1CombinedGoalsList = []
      this.ddlTerm2CombinedGoalsList = []
      this.ddlTerm3CombinedGoalsList = []
      this.ddlTerm4CombinedGoalsList = []

      this.ddlTerm1CusGoalsList = []
      this.ddlTerm2CusGoalsList = []
      this.ddlTerm3CusGoalsList = []
      this.ddlTerm4CusGoalsList = []
      this.ddlCustomGoalList = []
    },
    async levelSelect(rowData, crsID, level, semID, academicYear) {
      // this.$vs.loading();

      this.crsID = rowData.PK_Course_ID
      this.level = rowData.CRS_Level
      this.semID = rowData.ClS_FK_Semester_ID
      this.selectedAcademicYear = rowData.academicYear
      this.levelSelected = true
      this.resetAll()
      this.$router.push({ name: 'Level Goal Planner Assign', params: { data: rowData } })
      // this.ddlCustomGoalList = await this.getSaveCustomGoalList();
      // this.generateCustomDomainList(this.ddlCustomGoalList);
      // this.ddlGoalsList = await this.getPlannerMaster(rowData.CRS_Level);
      // await this.bindSemesterDetails();
      // this.ddlGoalsList.forEach(n => {
      //   const pos = this.ddlGoalsListDomain.indexOf(n.PlnMasDomain);
      //   if (pos === -1) {
      //     this.ddlGoalsListDomain.push(n.PlnMasDomain);
      //   }
      // });
      //
      // this.ddlTerm1GoalsList = await this.getLevelGoals(this.TermSemdID[0]);
      // this.ddlTerm2GoalsList = await this.getLevelGoals(this.TermSemdID[1]);
      // this.ddlTerm3GoalsList = await this.getLevelGoals(this.TermSemdID[2]);
      // this.ddlTerm4GoalsList = await this.getLevelGoals(this.TermSemdID[3]);
      //
      // this.ddlTerm1CusGoalsList = await this.getLevelCustomGoals(this.TermSemdID[0]);
      // this.ddlTerm2CusGoalsList = await this.getLevelCustomGoals(this.TermSemdID[1]);
      // this.ddlTerm3CusGoalsList = await this.getLevelCustomGoals(this.TermSemdID[2]);
      // this.ddlTerm4CusGoalsList = await this.getLevelCustomGoals(this.TermSemdID[3]);
      //

      //
      // this.goalRefresh++;
      this.$vs.loading.close()
    },
  },
}
</script>

<style>
#level-select-table th:last-child,
#level-select-table td:last-child {
  text-align: right !important;
}
</style>
